import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useParams, Link } from "react-router-dom";
import Select from "react-select";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import JsBarcode from "jsbarcode";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "../../../assets/css/customersummary.css";
import "jspdf-autotable";
import Moment from "moment";

//--------Material React Table------//
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import { handleSaveColumnOrder } from "../../../common/common";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";

const currentDate = new Date();
const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const month = monthNames[currentDate.getMonth()]; // add 1 to get month value from 1 to 12
const hours = currentDate.getUTCHours();
const minutes = currentDate.getUTCMinutes();

const BalanceSheetDetail = (props) => {
  const token = localStorage.getItem("Token");
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [totalbalance, setTotalBalance] = useState(0);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(7);
  const [nemultiselect, setnemultiselect] = useState({
    TransactionType: [],
  });
  const [columnOrder, setColumnOrder] = useState([]);
  const [columnVisibility, setColumnVisibility] = useState({});

  console.log(columnOrder , "columnOrdercolumnOrdercolumnOrdercolumnOrder")

  //----------------Server-Side------------------//
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  const loginuserid = localStorage.getItem("ID");

  const ITEMS_PER_PAGE = 10;

  const barcodeRefs = useRef([]);
  let index = 0;
  const [data, setData] = useState({
    inputValue: "",
    width: 1,
    height: 20,
    fontSize: 15,
    zeroFill: 10,
  });

  //Function to generate barcode
  const generateBarcodes = () => {
    barcodeRefs.current.forEach((barcodeRef, index) => {
      console.log("barcodeRefs", barcodeRefs);
      var g = document.getElementsByTagName(barcodeRef);
      const barcodeValue = paramObject.id;
      console.log("barcodeValue", barcodeValue);
      const paddedBarcodeValue = barcodeValue.padStart(data.zeroFill, "0");
      JsBarcode(barcodeRef, paddedBarcodeValue, {
        width: data.width,
        height: data.height,
        fontSize: data.fontSize,
        displayValue: true,
        fontoptions: "bold",
        textAlign: "center",
        font: "monospace",
        textPosition: "bottom",
        textMargin: 2,
        margin: 10,
        marginTop: undefined,
        marginBottom: undefined,
        marginLeft: undefined,
        marginRight: undefined,
        format: "CODE128",
        valid: () => true,
        background: "#ffffff",
        lineColor: "#000000",
        padding: data.zeroFill,
      });
    });
  };

  //Function for downloading pdf of barcodesheet

  //Function for download

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
  };

  //Function for lookup receipt
  const paramObject = useParams();
  const apicall = () => {
    const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return { columnname: el.id, value: el.value, id: index + 1 };
    });

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    axios
      .get(
        `${
          config.reportsBaseUrl
        }/reports/balancesheetdetail?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex}&pagesize=${
          pagination.pageSize
        }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
          globalFilter === undefined ? "" : globalFilter
        }&startdate=${startdate}&enddate=${enddate}&loginId=${loginuserid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res======>", res);
        console.log(res.data.ResponseData);
        if (res.data.ResponseCode === "SUCCESS") {
          const data = res.data.ResponseData.list;
          setnemultiselect({
            TransactionType: [
              ...new Set(data?.map((item) => item?.TransactionType)),
            ],
          });

          const mainData = data?.map((el) => {
            return {
              ...el,
              Name: el?.Name ? el?.Name : "",
              Num: el?.Num ? el?.Num : "",
            };
          });
          setResponseData(mainData);
          setData(mainData);
          setRowCount(res.data.ResponseData?.list[0]?.TotalRecord);

          setColumnOrder(res.data.ResponseData?.ColumnOrder?.length  > 0 ? res.data.ResponseData?.ColumnOrder.split(",") : ['mrt-row-select', ...columns.map((c) => c.accessorKey)]);
  
          // const keysToSetFalse = res.data.ResponseData?.ColumnsHide.length || "" ;
          const keysToSetFalse = res.data.ResponseData?.ColumnsHide.length > 0 ? res.data.ResponseData?.ColumnsHide : ['mrt-row-select', ...columns.map((c) => c.accessorKey)];
          console.log(keysToSetFalse , "keysToSetFalse")
          // Create default object with all values set to true
          const obj = columns.reduce((acc, item) => {
            acc[item.accessorKey] = true;
            return acc;
          }, {});
  
          // Comma-separated string of keys to set to false
  
          // Convert the string to an array and set the corresponding keys in the object to false
          keysToSetFalse.split(",").forEach((key) => {
            if (obj.hasOwnProperty(key)) {
              obj[key] = false;
            }
          });

          console.log(obj , "checkobj")
  
          setColumnVisibility(obj);
  

          //   barcodeRefs.current = responseData;
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    apicall();
  }, [
    columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    startdate,
    enddate,
  ]);

  useEffect(() => {
    generateBarcodes();

    console.log("barcodeRefs", barcodeRefs);
    // setLoading(true);

    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedDate======>", res);
        setSelectedDate(res.data.ResponseData);
        // setLoading(false);
        return res;
      });
  }, []);

  //Function for export excel

  // to calculate the total
  const calculateTotalSum = () => {
    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.Amount);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalSum(sum);
  };

  // to calculate the total
  const calculateTotalBalance = () => {
    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.Balance);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalBalance(sum);
  };

  useEffect(() => {
    calculateTotalSum();
    calculateTotalBalance();
  }, [responseData]);

  const callback = (payload, enddate2) => {
    console.log("stardate =>", payload);
    setStartDate(payload);
    setEndDate(enddate2);

    console.log("enddate =>", enddate2);
  };

  // const columnTypes = useMemo(() => {
  //   return {
  //     number: {
  //       editable: true,
  //       valueParser: (params) => {
  //         return parseInt(params.newValue);
  //       },
  //       aggFunc: 'sum',
  //     },
  //   };
  // }, []);

  const columns = [
    // DATE	TRANSACTION TYPE	NUM	NAME
    // MEMO/DESCRIPTION	SPLIT	DEBIT	CREDIT
    // AMOUNT	BALANCE	CREATE DATE	CREATED BY
    // LAST MODIFIED	LAST MODIFIED BY	PAYMENT METHOD

    {
      header: "Date",
      accessorKey: "Date",
      size: "120",
      filterFn: "contains",
      Cell: ({ row }) => Moment(row.original.Date).format("MM/DD/YYYY"),
    },
    {
      header: "Transaction Type",
      accessorKey: "TransactionType",
      filterSelectOptions: nemultiselect?.TransactionType, // ["paid", "unpaid"],
      filterVariant: "multi-select", //"select",
      enableColumnFilterModes: false,
    },
    {
      header: "Num",
      accessorKey: "Num",
      size: "100",
      filterFn: "contains",
      Cell: ({ row }) =>
        row.original.Num == "0" || "" ? "" : row.original.Num,
    },
    {
      header: "Name",
      accessorKey: "Name",
      size: "120",
      filterFn: "contains",
    },
    {
      header: "AccountName",
      accessorKey: "AccountName",
      size: "120",
      filterFn: "contains",
    },
    {
      header: "ChartOfAccountName",
      accessorKey: "ChartOfAccountName",
      size: "120",
      filterFn: "contains",
    },
    {
      header: "PaymentMethod",
      accessorKey: "PaymentMethod",
      size: "120",
      filterFn: "contains",
    },
    // { accessorKey: "Name" },
    {
      header: "Memo/Description",
      accessorKey: "Description",
      size: "120",
      filterFn: "contains",
    },
    {
      header: "Split",
      accessorKey: "Split",
    },

    {
      header: "Credit",
      accessorKey: "Credit",
      size: "100",
      filterFn: "contains",
      Cell: ({ row }) =>
        row.original.Credit == "0.00" || "" ? "" : row.original.Credit,
    },
    {
      header: "Debit",
      accessorKey: "Debit",
      size: "100",
      filterFn: "contains",
      Cell: ({ row }) =>
        row.original.Debit == "0.00" || "" ? "" : row.original.Debit,
    },
    {
      header: "Amount",
      accessorKey: "Amount",
      size: "100",
      filterFn: "contains",
      Cell: ({ row }) => {
        return parseFloat(row.original.Amount).toFixed(2);
      },
    },
    {
      header: "Balance",
      accessorKey: "Balance",
      size: "100",
      filterFn: "contains",
      Cell: ({ row }) => {
        return parseFloat(row.original.Balance).toFixed(2);
      },
    },
    {
      header: "Created Date",
      accessorKey: "CreatedDate",
      // size: "140",
      Cell: ({ row }) => {
        const CreatedDate = row?.original?.CreatedDate;
        if (
          CreatedDate === "00-00-0000" ||
          CreatedDate === "" ||
          CreatedDate === null
        ) {
          return "";
        }
        return moment(CreatedDate).format("MM/DD/YYYY h:mm A");
      },
    },
    {
      header: "Created By",
      accessorKey: "CreatedBy",
    },
    {
      header: "Last Modified",
      accessorKey: "LastModified",
      // size: "140",
      Cell: ({ row }) => {
        const LastModified = row?.original?.LastModified;
        if (
          LastModified === "00-00-0000" ||
          LastModified === "" ||
          LastModified === null
        ) {
          return "";
        }
        return moment(LastModified).format("MM/DD/YYYY h:mm A");
      },
    },
    {
      header: "Modified By",
      accessorKey: "ModifiedBy",
    },
    // {
    //   header: "Payment Method",
    //   accessorKey: "PaymentMethod",
    // },
  ];

  const defaultColDef = {
    sortable: true,
  };

  const autoGroupColumnDef = {
    comparator: (valueA, valueB, nodeA, nodeB, isDescending) => {
      var res = valueA == valueB ? 0 : valueA > valueB ? 1 : -1;
      return res;
    },
    field: "athlete",
    sort: "asc",
  };

  const totalFooterRow = {
    Customername: "Total",
    Amount: totalSum,
    Balance: totalbalance,
  };

  const augmentedData = [...responseData, totalFooterRow];

  const totalPages = Math.ceil(responseData.length / ITEMS_PER_PAGE);

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3>Open Purchase Order List</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">Balance Sheet Detail</li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Report period
              </label>
              <div className="row">
                <div className="col-md-11 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    // defaultValue={selectReport}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    value={reportdropdown.find((e) => e.value === selectReport)}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>

            <div className="col-sm-6 ">
              <div className="row">
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
              </div>
            </div>

            <div
              className="cursor-pointer col-md-3 d-flex justify-content-end mt-5"
              onClick={() =>
                handleSaveColumnOrder(
                  loginuserid,
                  "BalanceSheetReport",
                  columnOrder,
                  token,
                  // []
                  columnVisibility
                )
              }
              title="Lock Your Sequence"
            >
              <i class="fa fa-lock columnsLock fs-4"></i>
            </div>
          </div>

          {/* Receipt */}

          <div className="card mt-3">
            <div className="card-body">
              <div className="container">
                <div className="col-md-12 text-center " id="header">
                  <h6 className="p">SonarPos</h6>
                  <p className="fw-bold p-regular">Balance Sheet Detail</p>
                  <div className="row mb-2">
                    {/* <h6> Date: {new Date().toLocaleDateString()}</h6> */}
                    <p>
                      Date:{" "}
                      {startdate === "" && enddate === ""
                        ? "All Data"
                        : startdate + " - " + enddate}
                    </p>
                  </div>
                </div>
              </div>
              <hr />

              <div>
                <CommonMatrialReactTable
                  MainHeading="Sonar POS"
                  ReportHeading="Trial Balance Report"
                  columns={columns}
                  data={responseData}
                  startdate={startdate}
                  enddate={enddate}
                  columnGrouping={["ChartOfAccountName","AccountName"]}
                  setColumnOrder={setColumnOrder}
                  setColumnVisibility = {setColumnVisibility}
                  state={{
                    columnOrder,
                    columnVisibility,
                  }}
                  // rowCount = {rowCount}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BalanceSheetDetail;